import { useAssessmentsKeysQuery, useFormDefinitionsQuery, useLatestSubmittedFormSubmissionsQuery } from '@uplift/queries';
import { AssessmentKeys } from '@uplift/types';
import sortBy from 'lodash/sortBy';


export type AssessmentOption = {
  id: string;
  key: AssessmentKeys;
  name: string;
  lastCompletedAt?: string;
};


export const useAssessmentKeysList = () => {
  const { data: assessmentKeys } = useAssessmentsKeysQuery();
  const entries = Object.entries(assessmentKeys);
  const definitions = useFormDefinitionsQuery(entries.map(([ , formId ]) => formId));

  const items = entries.map(([ key, formId ], index) => ({
    key: key,
    formId: formId,
    name: definitions[index]?.name ?? key,
  }));

  return sortBy(items, item => item.name.toLowerCase());
};


export const useAssessmentOptions = (patientId: string): AssessmentOption[] => {
  const items = useAssessmentKeysList();
  const latestSubmissions = useLatestSubmittedFormSubmissionsQuery(patientId, items.map(item => item.formId));

  return items.map((item, index) => ({
    id: item.formId,
    key: item.key as AssessmentKeys,
    name: item.name,
    lastCompletedAt: latestSubmissions[index]?.completedAt,
  }));
};
